import React from 'react';
import { Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar.jsx';
import Home from './pages/Home/Home';
import CurrentWeekPage from './pages/CurrentWeek/CurrentWeekPage.jsx';
import Results from './pages/Results/Results';
import Leaderboard from './pages/Leaderboard/Leaderboard';
import Scoring from './pages/Scoring/Scoring';
import Admin from './pages/Admin/Admin';
import SuperAdmin from './pages/SuperAdmin/SuperAdmin';
import Login from './pages/Login/Login';
import RequireUser from './components/RequireUser.jsx';
import RequireAccessCode from './components/RequireAccessCode.jsx';
import AccessCodePage from './pages/AccessCode/AccessCode.jsx';
import AdminAccess from './components/ProtectedRoute.jsx';
import { AppAlertProvider } from './components/AppAlerts.jsx';

function App() {
  return (
    <AppAlertProvider>
      <div className="App">
        <NavBar />
        <div className="container my-4">
          <Routes>
            <Route path="/access-code" element={<AccessCodePage />} />

            <Route element={<RequireAccessCode />}>
              <Route path="/login" element={<Login />} />
              <Route element={<RequireUser />}>
                <Route path="/" element={<Home />} />
                <Route path="/picks" element={<CurrentWeekPage />} />
                <Route path="/results" element={<Results />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/scoring" element={<Scoring />} />
                <Route path="/admin" element={<AdminAccess><Admin /></AdminAccess>} />
                <Route path="/super-admin" element={<AdminAccess><SuperAdmin /></AdminAccess>} />
                <Route path="*" element={<Home />} />
              </Route>
            </Route>
          </Routes>
        </div>
      </div>
    </AppAlertProvider>
  );
}

export default App;
